import { Resource } from "shelving";

export const READ_NOTIFICATIONS = new Resource("readNotifications");
